import {
  config,
  total,
} from "assets/sidebar";
import { STATUS_PRODUCT } from "types";
import { PRIVATE_ROOT } from "utils/routes";
import { PowerSettingsNew, Settings, House, Apartment } from '@mui/icons-material';
import React from "react";


/** @format */
export const drawerWidth = 240;

export const dimension = {
  width: window.innerWidth,
  height: window.innerHeight,
};

export const KEY_CONTEXT = {
  AUTH_TOKEN: "authToken",
  REFRESH_TOKEN: "refreshToken",
  LANGUAGE: "language",
  THEME_MODE: "themeMode",
  USER: "user",
  SC_CONNECTION_TOKEN: "connectionToken",
  USER_ID: "userId",
  MODAL_REQUIRE: "modalRequire",
  DEFAULT_URL: "defaultUrl",
};

export const EmpLangSeclect = [
  {
    key: "EN",
    title: "English",
    value: "EN",
    useI18n: true,
  },
  {
    key: "VN",
    title: "Vietnamese",
    value: "VN",
    useI18n: true,
  },
];

export const defaultPagination = {
  total: 0,
  page: 0,
  pageSize: 25,
};

export enum EnumActionApproval {
  comment = "comment",
  approve = "approve",
  return = "return",
  reject = "reject",
  publish = "publish",
  archive = "archive",
  invite = "invite",
  delegate = "delegate",
  attach = "attach",
  print = "print",
  docversion = "docversion",
  history = "history",
  showmore = "showmore",
  lookup = "lookup",
}

export enum EnumBtnBottomModal {
  cancel = "cancel",
  approve = "approve",
  return = "return",
  reject = "reject",
  send = "send",
  save = "save",
  save_and_new = "save_and_new",
  ok = "ok",
  close = "close",
  /* Advance Search  */
  reset = "reset",
  save_as_profile = "save_as_profile",
  search = "search",
  downloadtemp = "downloadtemp",
  add = "add",
  update = "update",
  insert_update = "insert_update",
}

export enum EnumInputVariant {
  base = "base",
  browser = "browser",
  number = "number",
  select = "select",
}

export enum EnumValueDataType {
  String = "String",
  Number = "Number",
  Boolean = "Boolean",
  Object = "Object",
  Array = "Array",
  Null = "Null",
  Undefined = "Undefined",
  Function = "Function",
}

export enum EnumRangeApply {
  A = "A",
  S = "S",
}

export enum EnumYesNoBPMN {
  Y = "Yes",
  N = "No",
}

export enum EnumYesNo {
  Y = "Y",
  N = "N",
}

export enum EnumActionFilterBars {
  import = "import",
  export = "export",
  refresh = "refresh",
}

export const HEADER = {
  H_MOBILE: 64,
  H_DESKTOP: 80,
  H_DESKTOP_OFFSET: 80 - 16,
};

export const NAV = {
  WIDTH: 280,
};
export const EXPECT_LANG = ["ko", "en"];

export const QueryKeys = {
  GET_BRANDS: "get_brands",
  GET_CATEGORY: "get_category",
  GET_PRODUCT: "get_product",
};

export const ArrMenuSideBar = [
  {
    title: "概要（がいよう）",
    icon: total,
    to: PRIVATE_ROOT.DASHBOARD,
    subs: []
  },
  // {
  //   title: "設定（せってい）",
  //   icon: config,
  //   to: PRIVATE_ROOT.SETTING,
  // },
  // {
  //   title: "Xuất hoá đơn",
  //   icon: bill,
  //   to: PRIVATE_ROOT.POS,
  // },
  // {
  //   title: "Sửa chữa",
  //   icon: setting,
  //   subs: [
  //     {
  //       title: "Đơn sữa chữa",
  //       to: PRIVATE_ROOT.BOOK,
  //     },
  //     {
  //       title: "Quy trình sữa chữa",
  //       to: PRIVATE_ROOT.REPAIR,
  //     },
  //     {
  //       title: "Báo cáo sữa chữa",
  //       to: PRIVATE_ROOT.COMMISSION,
  //     },
  //     {
  //       title: "Doanh số sữa chữa",
  //       to: PRIVATE_ROOT.FIX,
  //     },
  //   ],
  // },
  // {
  //   title: "Bảo hành",
  //   icon: grad,
  //   subs: [
  //     {
  //       title: "Đơn bảo hành",
  //       to: PRIVATE_ROOT.WARRANTY,
  //     },
  //     {
  //       title: "Quy trình bảo hành",
  //       to: PRIVATE_ROOT.ITEM,
  //     },
  //     {
  //       title: "Báo cáo bảo hành",
  //       to: PRIVATE_ROOT.WARRP,
  //     },
  //   ],
  // },
  // {
  //   title: "Đơn hàng",
  //   icon: order,
  //   to: PRIVATE_ROOT.ORDERS,
  // },
  // {
  //   title: "Khách hàng",
  //   icon: customer,
  //   to: PRIVATE_ROOT.CUSTOMER,
  // },
  // {
  //   title: "Sản phẩm",
  //   icon: product,
  //   subs: [
  //     {
  //       title: "Danh sách sản phẩm",
  //       to: PRIVATE_ROOT.PRODUCT,
  //     },
  //     {
  //       title: "Nhập kho",
  //       to: PRIVATE_ROOT.INPUT,
  //     },
  //     {
  //       title: "Chuyển kho",
  //       to: PRIVATE_ROOT.TRANSFER,
  //     },
  //     {
  //       title: "Tồn kho",
  //       to: PRIVATE_ROOT.INVENTORY,
  //     },
  //   ],
  // },
  // {
  //   title: "Thu - Chi",
  //   icon: pay,
  //   subs: [
  //     {
  //       title: "Phiếu thu",
  //       to: PRIVATE_ROOT.RECEIPT,
  //     },
  //     {
  //       title: "Phiếu chi",
  //       to: PRIVATE_ROOT.PAYMENT,
  //     },
  //     {
  //       title: "Sổ quỹ",
  //       to: PRIVATE_ROOT.CASHBOOK,
  //     },
  //   ],
  // },
  // {
  //   title: "Doanh số",
  //   icon: analytics,
  //   subs: [
  //     {
  //       title: "Lợi nhuận",
  //       to: PRIVATE_ROOT.PROFIT,
  //     },
  //     {
  //       title: "Doanh số tổng",
  //       to: PRIVATE_ROOT.REVENUE,
  //     },
  //     {
  //       title: "Báo cáo tổng hợp",
  //       to: PRIVATE_ROOT.REPORT,
  //     },
  //   ],
  // },

];

export const StatusFilter = [
  { title: "Đang kinh doanh", id: STATUS_PRODUCT.BUSINESS },
  { title: "Đã ngừng kinh doanh", id: STATUS_PRODUCT.STOP_BUSINESS },
  { title: "Đã xoá", id: STATUS_PRODUCT.DELETE },
];
//
export const userOptionsData = [
  { id: 1, key: 'setting', icon: <Settings />, title: 'Setting', useI18n: true },
  { id: 3, key: 'logout', icon: <PowerSettingsNew />, title: 'Logout', useI18n: true },
];

export const downloadExcelOptionsData = [
  { id: 1, key: 'apartment', icon: <Apartment />, title: 'アパート', useI18n: true },
  { id: 2, key: 'house', icon: <House />, title: '家', useI18n: true },
];
